import OrzioLogo from "./OrzioLogo";
import OrzioLoader from "./OrzioLoader";

interface SplashScreenProps {
  label?: string;
}

export default function SplashScreen({ label = "A preparar o Orzio..." }: SplashScreenProps) {
  return (
    <div className="orzio-splash" role="status" aria-live="polite" aria-label={label}>
      <div className="orzio-splash__surface">
        <OrzioLogo variant="stacked" size="lg" />
        <OrzioLoader size="sm" label={label} showProgress />
      </div>
    </div>
  );
}
